import { Component, OnInit, Input } from '@angular/core';
import { IonIcon, IonSpinner } from '@ionic/angular/standalone';

import { DemoozColor, DemoozColorPrimary } from '@demooz/types';

@Component({
  selector: 'demooz-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [IonIcon, IonSpinner]
})
export class DemoozButtonComponent  implements OnInit {

    @Input({alias : 'type', required : false}) typeButton: 'submit'|'button' = 'button';
    @Input({alias : 'label', required : false}) labelButton: string = '';
    @Input({alias : 'icon', required : false}) iconButton: string = '';
    @Input({alias : 'rounded', required : false}) roundedButton: boolean = false;
    @Input({alias : 'color', required : false}) colorButton: DemoozColor;
    @Input({alias : 'disabled', required : false}) disabledButton: boolean = false;
    @Input({alias : 'hideLabelDevice', required : false}) hideLabelDevice: 'phone'|'tablet';
    @Input({alias : 'size', required : false}) sizeButton: 'big'|'medium'|'small' = 'medium';
    @Input({alias : 'withMargin', required : false}) withMargin: boolean = true;
    @Input({alias : 'fullSize', required : false}) fullSize: boolean = false;
    @Input({alias : 'isFetching', required : false}) isFetching: boolean = false;
    @Input({alias : 'invertColor', required : false}) invertColor: boolean = false;
    @Input({alias : 'withShadow', required : false}) withShadow: boolean = false;
    @Input({alias : 'withBorder', required : false}) withBorder: boolean = true;

    constructor() { }

    ngOnInit() {}

}
